var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.75 9.06885V5.31885C15.75 4.72211 15.5129 4.14981 15.091 3.72786C14.669 3.3059 14.0967 3.06885 13.5 3.06885H7.5C6.90326 3.06885 6.33097 3.3059 5.90901 3.72786C5.48705 4.14981 5.25 4.72211 5.25 5.31885V18.8188C5.25 19.4156 5.48705 19.9879 5.90901 20.4098C6.33097 20.8318 6.90326 21.0688 7.5 21.0688H13.5C14.0967 21.0688 14.669 20.8318 15.091 20.4098C15.5129 19.9879 15.75 19.4156 15.75 18.8188V15.0688M12 9.06885L9 12.0688M9 12.0688L12 15.0688M9 12.0688H21.75",
    stroke: "#EC722E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5c04be2c61c7211e02d424b02f0e7c6c.svg";
export { ForwardRef as ReactComponent };